import { h } from "preact";
import { Alert, Grid, Typography, Paper, Button, Box, Tooltip, Stack, } from "@mui/material";
import { dedupArrayOfObjects, addFromToURL } from "../Common/functions";
export function redThreadDealUser(state, app) {

    var deal = state.actualDeal;
    if (deal && ((deal.md && deal.md.length > 0) || (deal.omd && deal.omd.length > 0))) {

        var lbl00 = (<div>
            <Typography variant="h5" style="margin-bottom: 10px;">Attention, il vous reste des actions pour faire progresser le dossier</Typography>
            {deal.md && deal.md.length > 0 && deal.omd && deal.omd.length > 0 && <Typography style="margin-bottom: 5px;" variant={"h5"}>Pour vous-même</Typography>}
            {deal.md.map((md, idx) => {
                return <Typography variant="body1">{idx + 1} {md.label} {md.action.u === true ? "en attendant que " + md.label.r : ""}</Typography>
            })
            }
        </div>)

        var actions = dedupArrayOfObjects(deal.md).reduce((acc, action) => {

            if (action !== null) {
                if (action.p === true) { return acc; }
                return acc.concat(<Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                        window.location.href = action.u;
                    }}
                >
                    {action.l}
                </Button>)
            }

        }, [])



        app.refHeader.current.handleChangeState({
            guidelines: {
                message: lbl00,
                message_proxied: deal.omd,
                actions: actions,
            }
        })
    }

}

export function redThreadUser(state, app, type) {
    // console.log("redThreadUser", state.ctx)
    if (state.ctx && state.ctx.user_undone.length > 0) {
        var lbl = (
            <div>
                <Typography variant="h5">Attention, votre profil {type} n'est pas complet,</Typography>
                <Typography variant="h5">Pour bénéficier des fonctionnalités de Bkeys, il faut</Typography>
                {state.ctx.user_undone.map((d, idx) => {
                    return <Typography>{d.label}</Typography>
                })}
            </div>
        );
        var actions = dedupArrayOfObjects(state.ctx.user_undone).reduce((acc, action) => {
            //console.log(u.action);
            if (action !== null) {
                return acc.concat(<Button
                    variant="contained"
                    onClick={() => {
                        window.location.href = addFromToURL(action.u);
                    }}
                >
                    {action.l}
                </Button>)
            }

        }, [])

        app.refHeader.current.handleChangeState({
            guidelines: {
                message: lbl,
                actions: actions, //[{ u: "/user", l: "Compléter mon profil" }],
                //icon: icon
            }
        })
        return
    }

    var url = "";

    switch (type) {
        case "vendeur":
            url = "/11d1355181ac4376a09980601b420617/";

            break;
        case "acquéreur":
            url = "/1fdf58e512f54752959b369588380557/";

            break;
        case "ambassadeur":
            url = "/7bac6cb9d6ee4d70b1315393725f3a34/";

            break;
        case "notaire":
            url = "/508f2de0fa994052a6d0cbc0c3b4d8c7/";

            break;
    }

    if (state.ctx && state.ctx.deals && state.ctx.deals.filter((d) => { return d.md.length > 0 }).length > 0) {
        var filtered = state.ctx.deals.filter((d) => { return d.md.length > 0 });
        //console.log("attn", filtered)

        var lbl00 = <div>
            <Typography variant="h5" style="margin-bottom: 10px;">Attention, il vous reste des actions à effectuer sur le{filtered.length > 1 ? "s" : ""} dossier{filtered.length > 1 ? "s" : ""} suivant{filtered.length > 1 ? "s" : ""}</Typography>
            {filtered.map((dl, idx) => {
                //console.log(dl.md)
                return <Tooltip title={<span>{dl.md.map((ln) => { return <div>{ln.label}</div> })}</span>}>
                    <Button style="margin-right: 10px; margin-top: 10px;" variant="contained" onClick={() => (state.ctx.user_undone.length == 0 ? (window.location.href = url + dl.u) :
                        app.refPopUp.current.handleChangeState(
                            {
                                opened: true,
                                type: "005",

                            })
                    )}>Dossier de vente {dl.rk}</Button>
                </Tooltip>
            })}
        </div>
        app.refHeader.current.handleChangeState({
            guidelines: {
                message: lbl00,

            }
        })
    }
}